import PriceMixin from "@/view/mixins/PriceMixin";

export default {
  mixins: [PriceMixin],
  computed: {
    vonqPrice() {
      return this.findPriceOrDefault(
        this.product,
        "vonq_price",
        this.currency.code
      );
    },
    ratecardPrice() {
      return this.findPriceOrDefault(
        this.product,
        "ratecard_price",
        this.currency.code
      );
    }
  }
};
